import ES6Promise from "es6-promise";
import axios from "axios";

ES6Promise.polyfill();

export const BASE_URL = window.env.SERVICE_BACKEND;

// To use in servers
function getAuth() {
  const loginInfo = JSON.parse(sessionStorage.getItem("loginDetails"));
  const auth = `Bearer ${loginInfo.access_token}`;
  return auth;
}

export function getTokenInfo() {
  return axios.get(window.env.TOKEN_INFO, {
    headers: {
      Authorization: getAuth()
    }
  });
}

/**EP 1.0 */

export function getAccessByHour() {
  return axios.get(`${BASE_URL}security/accessByHour`, {
    headers: {
      Authorization: getAuth()
    }
  });
}

/**EP 2.0 */

export function getPurchaseOrder(params) {
  return axios.get(`${BASE_URL}globalData/purchaseOrder/${params}`, {
    headers: {
      Authorization: getAuth()
    }
  });
}
export function updateHeader(params) {
  return axios.put(`${BASE_URL}globalData/updatePurchaseOrder`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function getPurchaseOrderDetail(purchaseOrder, suffix) {
  return axios.get(
    `${BASE_URL}globalData/purchaseOrderDetail/${purchaseOrder}/${suffix}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function updateHeaderDetail(params) {
  return axios.put(`${BASE_URL}globalData/updatePurchaseOrderDetail`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}
export function addItem(params) {
  return axios.post(`${BASE_URL}globalData/addItem`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}
export function resendPurchaseOrder(params) {
  return axios.put(
    `${BASE_URL}globalData/resendPurchaseOrder/${params}`,
    {},
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

/* EP3.0 */

export function getVendorInformation(itemNumber, whse) {
  return axios.get(
    `${BASE_URL}itemMaintenance/itemVendor/${itemNumber}/${whse}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function checkChgVendorAvailability(
  originalVendorId,
  newVendorId,
  whse,
  vendorType
) {
  return axios.get(
    `${BASE_URL}itemMaintenance/itemVendor/chgVendor/${originalVendorId}/${newVendorId}/${whse}/${vendorType}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function getWhseList() {
  return axios.get(`${BASE_URL}itemMaintenance/whses`, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function updateVendorInformation(params) {
  return axios.put(`${BASE_URL}itemMaintenance/updateItemVendor`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

// Batch update multiple vendor information records
export function batchUpdateVendorInformation(batchData) {
  return axios.post(`${BASE_URL}itemMaintenance/updateBatchItemVendor`, batchData, {
    headers: {
      Authorization: getAuth()
    }
  });
}

/* EP4.0 */
export function getItemLevel(itemNumber, whse) {
  return axios.get(
    `${BASE_URL}forecastReplenishment/itemLevel/${itemNumber}/${whse}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function updateItemForecastReplenishment(params) {
  return axios.put(`${BASE_URL}forecastReplenishment/updateItemLevel`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}
/* EP5.0 */
export function getItemWhseChg(itemNumber, whse) {
  return axios.get(
    `${BASE_URL}itemMaintenance/itemWhseChg/${itemNumber}/${whse}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function validateCorePendDateRetail(
  coreRetail,
  CorePendDate,
  corePendRetail
) {
  return axios.get(
    `${BASE_URL}itemMaintenance/corePendDateRetailChg/${coreRetail}/${CorePendDate}/${corePendRetail}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function validateOrderType(orderType) {
  return axios.get(`${BASE_URL}itemMaintenance/orderTypeChg/${orderType}`, {
    headers: {
      Authorization: getAuth()
    }
  });
}
export function validateDirectReplenFlag(
  directReplenFlag,
  itemNumber,
  whseIntl,
  whseBroker
) {
  return axios.get(
    `${BASE_URL}itemMaintenance/directReplenFlagChg/${directReplenFlag}/${itemNumber}/${whseIntl}/${whseBroker}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function updateItemWhse(params) {
  return axios.put(`${BASE_URL}itemMaintenance/updateItemWhseChg`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}
/* EP6.0 */
export function getItemVolumetricInfoByDC(itemNumber, whse) {
  return axios.get(
    `${BASE_URL}itemMaintenance/itemVolumetricInfoByDC/${itemNumber}/${whse}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function updateItemVolumetricInfoByDC(params) {
  return axios.put(
    `${BASE_URL}itemMaintenance/updateItemVolumetricInfo`,
    params,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 7.0 */

export function lookItemShipHistory(itemNumber, whse, year) {
  return axios.get(
    `${BASE_URL}itemMaintenance/lookItemShipHistory/${itemNumber}/${whse}/${year}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 8.0 */

export function forecastReplenishByVendorAndDC(vendor, whse) {
  return axios.get(
    `${BASE_URL}forecastReplenishment/forecastReplenishByVendorAndDC/${vendor}/${whse}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function updateForecastReplenishByVendorAndDc(params) {
  return axios.put(
    `${BASE_URL}forecastReplenishment/updateForecastReplenish`,
    params,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 9.0 */
export function getVendorInformationByVendorAndDC(vendor, whse) {
  return axios.get(
    `${BASE_URL}vendorMaintenance/vendorInformationByVendorAndDC/${vendor}/${whse}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
export function updateVendorInformationByVendorAndDC(params) {
  return axios.put(
    `${BASE_URL}vendorMaintenance/updateVendorInformation`,
    params,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 10.0 */
export function getVendorInformationBydDC(vendor, whse) {
  return axios.get(
    `${BASE_URL}vendorMaintenance/getVendorInfByDC/${vendor}/${whse}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 11.0 */
export function getVendorInformationByNumber(vendor) {
  return axios.get(
    `${BASE_URL}vendorMaintenance/vendorLevelInformationByVendor/${vendor}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 13.0 */
export function getitemLevelInformationByItem(item) {
  return axios.get(
    `${BASE_URL}itemMaintenance/itemLevelInformationByItem/${item}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 12.0 */
export function getSystemTrackingByPoAndDC(purchaseOrder, suffix) {
  return axios.get(
    `${BASE_URL}yardManagement/getSystemTracking/${purchaseOrder}/${suffix}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 14.0 */
export function getVendorLevelInformationReducedByVendorNumber(item) {
  return axios.get(
    `${BASE_URL}vendorMaintenance/vendorLevelInformationReducedByVendor/${item}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}
/**EP 15.0 */
export function getVendorLevelInformationReducedByVendorName(item) {
  return axios.get(
    `${BASE_URL}vendorMaintenance/vendorLevelInformationReducedByVendorName/${item}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function updateVendorInfByDc(params) {
  return axios.put(`${BASE_URL}vendorMaintenance/updateVendorInfByDC`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

/**MOQ endpoints */

export function postExcelData(params) {
  return axios.post(`${BASE_URL}moqMaintenance/uploadMoqInfo`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function saveMOQ(params) {
  return axios.post(`${BASE_URL}moqMaintenance/saveMoqInfo`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function deleteMOQ(params) {
  return axios.post(`${BASE_URL}moqMaintenance/deleteMoqs`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function getMOQbyVendor(vendor) {
  return axios.get(
    `${BASE_URL}moqMaintenance/getMoqInfoByVendor/${vendor}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getMOQbyItem(item) {
  return axios.get(
    `${BASE_URL}moqMaintenance/getMoqInfoByItem/${item}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getMOQbyItemAndVendor(item, vendor) {
  return axios.get(
    `${BASE_URL}moqMaintenance/getMoqInfoByItemVendor/${item}/${vendor}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getMOQInfo() {
  return axios.get(
    `${BASE_URL}moqMaintenance/getMoqInfo`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}


/**Alt vendor endpoints */

export function uploadAltVendor(params) {
  return axios.post(`${BASE_URL}altVendorMaintenance/uploadAltVedorInfo`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function saveAltVendor(params) {
  return axios.post(`${BASE_URL}altVendorMaintenance/saveAltVendorInfo`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function deleteAltVendor(params) {
  return axios.post(`${BASE_URL}altVendorMaintenance/deletAltVendors`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function getAltVendByItem(item) {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfoByItem/${item}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getAltVendByMajor(major) {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfoByMajor/${major}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getAltVendByMinor(minor) {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfoByMinor/${minor}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getAltVendByAltVendor(altVendor) {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfoByAltVendor/${altVendor}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getAltVendByPrimaryVendor(primaryVendor) {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfoByPrimaryVendor/${primaryVendor}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getAltVendByMajorAndMinor(major, minor) {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfoByMajorMinor/${major}/${minor}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getAltVendByItemAndAltVend(item, altVend) {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfoByItemAndAltVendor/${item}/${altVend}`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}

export function getAltVendorInfo() {
  return axios.get(
    `${BASE_URL}altVendorMaintenance/getAltVendorInfo`,
    {
      headers: {
        Authorization: getAuth()
      }
    }
  );
}


/* ASN endpoints */

export function uploadASN(params) {
  return axios.post(`${BASE_URL}advance-shipping-notices/overrides/validate-fetch-data`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function saveASN(params) {
  return axios.post(`${BASE_URL}advance-shipping-notices/overrides/save`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function deleteASN(params) {
  return axios.post(`${BASE_URL}advance-shipping-notices/overrides/delete`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

export function searchASN(params) {
  return axios.post(`${BASE_URL}advance-shipping-notices/overrides/search`, params, {
    headers: {
      Authorization: getAuth()
    }
  });
}

